import { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { deleteDoc, doc, onSnapshot } from 'firebase/firestore';

import { getAuth, deleteUser, updateProfile } from 'firebase/auth';

import { getDownloadURL, ref } from 'firebase/storage';

import { db, storage } from '../../firebase_config';

import { UserContext } from '../UserContext';

import { ModalWindow } from '../../Components/ModalWindow';

import { toast } from 'react-toastify';

export const ProfilePanel = () => {
  const { userName, setUserName } = useContext(UserContext);
  const navigate = useNavigate();
  const user = getAuth().currentUser;
  const docRef = doc(db, 'users', user.uid);
  const [userPhoto, setUserPhoto] = useState(null);
  const fileRef = ref(storage, user.uid + '.png');

  const [isModalOpened, setOpenModal] = useState(false);

  const handleDeleteUser = () => {
    toast.success('Deletion successful', {
      position: 'top-center',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
    });
    setOpenModal(false);
    deleteDoc(docRef);
    deleteUser(user)
      .then(() => {
        navigate('/', { replace: true });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  async function updateUserData() {
    const photoURL = await getDownloadURL(fileRef);
    updateProfile(user, { photoURL });
    setUserPhoto(user.photoURL);
  }

  onSnapshot(docRef, (doc) => {
    if (user) {
      if (userName) {
        setUserName(doc.data().name);
      }
      updateUserData();
    }
  });

  return (
    <div className="mobile:p-5 bg-shadow border border-background rounded-2xl min-w-320">
      <div className="flex justify-center items-center flex-col relative">
        <button
          onClick={() => setOpenModal(true)}
          className="absolute top-56 mobile:top-60 right-4 mobile:right-0 animate-shadowPulse bg-like rounded-full w-16 mobile:w-20 h-16 mobile:h-20 text-font font-medium md:font-semibold leading-7 text-base md:text-lg">
          Delete User
        </button>
        <div className="border-4 border-background rounded-full h-32 w-32 flex justify-center items-center">
          {userPhoto ? (
            <img src={userPhoto} className="rounded-full h-32 w-32 block" alt="avatar" />
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-12 h-12 m-auto stroke-borderColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
              />
            </svg>
          )}
        </div>
        <div>
          <h3 className="flex items-end ml-5 px-0 mobile:px-2 shadow-profileTItle font-poppins text-xl">
            <span className="font-medium text-black mr-4">NAME:</span>
            <p className="font-bold text-background">{userName}</p>
          </h3>
          <h3 className="flex items-end ml-5 px-0 mobile:px-2 shadow-profileTItle font-poppins text-xl">
            <span className="font-medium text-black mr-4">LOGIN:</span>
            <p className="font-bold text-background">{user.email}</p>
          </h3>
        </div>
      </div>
      <h3 className="flex justify-center mt-5 p-0 mobile:p-1 shadow-profileTItle font-poppins text-xs">
        <span className="font-medium text-background mr-4">Your ID: </span>
        <p className="font-bold text-background">{user.uid}</p>
      </h3>
      {isModalOpened && (
        <ModalWindow closeModal={() => setOpenModal(false)}>
          <div className="mt-10 flex flex-col gap-5 justify-center items-center p-3 smart:p-5 ">
            <h2 className="font-crimson font-bold text-lg md:text-xl leading-6 flex tracking-wider text-center">
              Are you sure you want to delete your data?
            </h2>
            <div className="flex gap-4 justify-center items-center">
              <button
                className="h-12 w-28 font-crimson font-normal text-lg leading-8 tracking-wider flex justify-center items-center duration-500 bg-transparent border-2 rounded-3xl border-like hover:text-font hover:bg-like"
                onClick={handleDeleteUser}>
                Yep
              </button>
              <button
                className="h-12 w-28 font-crimson font-normal text-lg leading-8 tracking-wider flex justify-center items-center duration-500 bg-transparent border-2 rounded-3xl border-borderColor hover:text-font hover:bg-borderColor"
                onClick={() => setOpenModal(false)}>
                Nope
              </button>
            </div>
          </div>
        </ModalWindow>
      )}
    </div>
  );
};
